<template>
    <div class="form">
        <Form ref="info" :model="info" :rules="ruleValidate" :label-width="100">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="客户姓名" prop="username">
                        <Input disabled v-model="reportInfo.username" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="手机号" prop="phone">
                        <Input disabled v-model="reportInfo.phone" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="意向楼盘" prop="projName">
                        <Input disabled v-model="reportInfo.projName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="当前置业顾问" prop="currUserName">
                        <Input disabled v-model="reportInfo.currUserName" :maxlength="256" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="意向面积" prop="area">
                        <Input v-model="info.area"
                            type="textarea" :rows="2"
                            placeholder="如40㎡以下、40㎡ ~ 60㎡、60㎡ ~ 90㎡、90 ~ 130㎡、130㎡ ~ 200㎡、200㎡以上">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="购房用途" prop="purpose">
                        <Input v-model="info.purpose"
                            type="textarea" :rows="2"
                            placeholder="如自用、投资等">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="关注因素" prop="factors">
                        <Input v-model="info.factors" 
                            type="textarea" :rows="2"
                            placeholder="如朝向、采光、户型、面积、价格等">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="意向级别" prop="grade">
                        <Input v-model="info.grade"
                            type="textarea" :rows="2" 
                            placeholder="如A（必买）、B（高意向）、C（一般意向）、D（无意向）等">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="家庭情况" prop="familySituation">
                        <Input v-model="info.familySituation"
                            type="textarea" :rows="2"
                            placeholder="如单身贵族、二人世界、单亲家庭、二代之家、三代同堂、未知等">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="年龄段" prop="ageGroup">
                        <Input v-model="info.ageGroup"
                            type="textarea" :rows="2"
                            placeholder="如40岁以上、30 ~ 40岁、20 ~ 30岁、20岁以下">
                        </Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import { customerReportView } from '@/api/customer-recommend'
import { receptionDetailed, receptionAdd, receptionUpdate } from '@/api/customer-reception'

export default {
    name: 'FormReception',

    props: {
        id: {
            type: [String, Number],
            default: ''
        }
    },

    components: {},

    inject: {
        $modal: {
            default: null
        }
    },

    data() {
        return {
            loading: false,
            reportInfo: {
                id: this.id,
                customerId: '',     // 客户编号(新增需要)
                intentionId: '',    // 意向楼盘编号(新增需要)
                brokerId: '',       // 经纪人编号(新增需要)
                username: '',       // 客户姓名
                phone: '',          // 手机号
                projName: '',       // 项目名称
                currUserName: '',   // 当前置业顾问
            },
            info: {
                id: '',                 // 客户招待编号
                customerId: '',         // 客户编号
                reportId: this.id,      // 报备数据编号
                brokerId: '',           // 经纪人编号
                projId: '',             // 意向楼盘编号
                area: '',               // 意向面积
                purpose: '',            // 购房用途
                factors: '',            // 关注因素
                grade: '',              // 意向级别
                familySituation: '',    // 家庭情况
                ageGroup: '',           // 年龄段
                ver: ''                 // 版本号
            }
        }
    },

    computed: {
        ruleValidate() {
            return {}
        }
    },

    methods: {},

    mounted() {
        var $info = this.$refs.info
        // 按钮
        this.$modal.updateBtns([
            { type: 'primary', text: '确认接待', name: 'confirm' },
            { type: 'default', text: '关闭', name: 'cancel' }
        ])
        // 预加载
        this.$modal.beforeEnter(next => {
            Promise.all([
                customerReportView(this.id)
            ])
            .then(args => {
                var [view] = args
                if (view) {
                    var viewData = view.data
                    Object.keys(this.reportInfo).forEach(
                        name => (this.reportInfo[name] = viewData[name])
                    )

                    // 查询客户接待信息
                    var body = {
                        customerId: this.reportInfo.customerId,
                        reportId: this.reportInfo.id,
                        brokerId: this.reportInfo.brokerId,
                        projId: this.reportInfo.intentionId
                    }
                    Promise.all([
                        receptionDetailed(body)
                    ])
                    .then(arg => {
                        var [reception] = arg
                        if (reception) {
                            var detailed = reception.data
                            Object.keys(this.info).forEach(
                                name => (this.info[name] = detailed[name])
                            )
                        }
                    })
                }
            })
            .finally(() => {
                next()
            })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info.validate()
                .then(() => {
                    this.loading = true
                    var formData = null
                    if (this.info.id) {
                        formData = Object.assign({}, this.info)
                        return receptionUpdate(formData)
                    } else {
                        this.info.customerId = this.reportInfo.customerId
                        this.info.reportId = this.reportInfo.id
                        this.info.brokerId = this.reportInfo.brokerId
                        this.info.projId = this.reportInfo.intentionId
                        formData = Object.assign({}, this.info)
                        return receptionAdd(formData)
                    }
                })
                .then(res => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch(err => {
                    options.closeModal = false
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    }
}
</script>
<style lang="less" scoped>
</style>
